import type { UpgradeCodeResponse } from '@kimuno/api-sdk';

import type { AsyncAction } from './common.actionTypes';

export enum FETCH_UPGRADE_CODE {
	START = 'FETCH_UPGRADE_CODE_START',
	SUCCESS = 'FETCH_UPGRADE_CODE_SUCCESS',
	ERROR = 'FETCH_UPGRADE_CODE_ERROR',
}

export type FetchUpgradeCodeAction = AsyncAction<
	typeof FETCH_UPGRADE_CODE.START,
	typeof FETCH_UPGRADE_CODE.SUCCESS,
	typeof FETCH_UPGRADE_CODE.ERROR,
	UpgradeCodeResponse,
	{ upgradeCode: string }
>;
